<template>
  <div>
    <base-page-heading title="WO Incentive Report" />
    <div class="content">
      <incentive-list-filter
        class="mb-0"
        :columns="columns"
        :initial-filters="filters"
        @filters-applied="applyFilters"
      />
      <incentive-table
        class="mt-3"
        :filters="filters"
        :columns="columns"
        v-bind="{ ...sorting, ...pagination }"
      />
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';
import listMixin from '@/mixins/listMixin';
import { WORK_ORDER_INCENTIVE_REPORT_TABLE_NAME } from '@/constants/reports';
import IncentiveListFilter from '@/components/admin/reports/workOrders/IncentiveListFilter.vue';
import IncentiveTable from '@/components/admin/reports/workOrders/IncentiveTable.vue';

export default {
  name: 'WorkOrderIncentiveReport',
  components: {
    IncentiveTable,
    IncentiveListFilter,
  },
  mixins: [listMixin],
  props: {
    client_ids: {
      type: Array,
      default: () => [],
    },
    user_ids: {
      type: Array,
      default: () => [],
    },
    checked_out_from: String,
    checked_out_to: String,
    sortBy: {
      type: String,
      default: 'incentive_payout_cents',
    },
  },
  data() {
    // Default to last Sun–Sat week (same as Admin Dashboard "Previous Week")
    // Use LLL d, yyyy so it matches the date picker / filter format exactly.
    const lastWeekStart = DateTime.now().startOf('week').minus({ week: 1, day: 1 });
    const lastWeekEnd = DateTime.now().startOf('week').minus({ day: 2 });
    const formatDate = (dt) => dt.setLocale('en').toFormat('LLL d, yyyy');

    const filters = {
      checked_out_from: this.checked_out_from || formatDate(lastWeekStart),
      checked_out_to: this.checked_out_to || formatDate(lastWeekEnd),
    };
    if (this.client_ids?.length) {
      filters.client_ids = this.client_ids;
    }
    if (this.user_ids?.length) {
      filters.user_ids = this.user_ids;
    }

    return {
      tableName: WORK_ORDER_INCENTIVE_REPORT_TABLE_NAME,
      filters,
    };
  },
};
</script>
